import { render, staticRenderFns } from "./ToufangBroad.vue?vue&type=template&id=24880197&scoped=true&"
import script from "./ToufangBroad.vue?vue&type=script&lang=js&"
export * from "./ToufangBroad.vue?vue&type=script&lang=js&"
import style0 from "./ToufangBroad.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ToufangBroad.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ToufangBroad.vue?vue&type=style&index=2&id=24880197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24880197",
  null
  
)

export default component.exports